import { useEffect } from 'react';
import ADD_QUERY_INSIGHT from '../graphql/ADD_QUERY_INSIGHT';
import INSERT_SEARCH_INFO from '../graphql/INSERT_SEARCH_INFO';
import { useMutation } from '@apollo/client';

const useInsightSubmit = (query, tracking, shouldExecute) => {

	const {  HSID, OID, EID, SID, UID, ip } = tracking;

    const [ insertSearchInfo ] = useMutation(INSERT_SEARCH_INFO, { 
        onCompleted: () => console.log('SearchInfo posted to CF.') 
    });

    const [ addQueryInsight ] = useMutation(ADD_QUERY_INSIGHT, { 
        onCompleted: () => console.log('QueryInsight posted to Mongo.') 
    });

	useEffect(() => {
        if(shouldExecute) {
            insertSearchInfo({
                variables: {
                    visitor: {
                        'hsid': Number(HSID),
                        'oid': Number(OID),
                        'eid': EID,
                        'sid': Number(SID),
                        'uid': UID,
                        'ip_address': ip,
                        'query': query
                    }
                }
            });
            addQueryInsight({ 
                variables: { 
                    clickId: Number(HSID), 
                    query: query
                } 
            })
        }
		// eslint-disable-next-line
	}, [shouldExecute]);

	return;
};

export default useInsightSubmit;